import { AnimatePresence } from 'framer-motion';
import { graphql, useStaticQuery } from 'gatsby';
import React, { useState } from 'react';
import { getMenuItemUrl } from '../../helpers/menu-item';
import Link from '../atoms/Link';
import Logo from '../atoms/Logo';
import { MobileMenu } from '../molecules/MobileMenu';
import Nav from '../molecules/Nav';

const Header = () => {
  const {
    mainMenu: { columns },
    ctaMenu: { columns: ctaColumns },
  } = useStaticQuery(graphql`
    {
      mainMenu: contentfulMenu(location: { eq: "Header" }) {
        name
        columns {
          items {
            label
            targetPage {
              url
            }
            externalUrl
            subitems {
              label
              targetPage {
                url
              }
              externalUrl
            }
          }
        }
      }
      ctaMenu: contentfulMenu(location: { eq: "Header CTA" }) {
        name
        columns {
          items {
            label
            targetPage {
              url
            }
            externalUrl
          }
        }
      }
    }
  `);
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  const items = columns[0].items;
  const ctaItems = ctaColumns[0].items;

  return (
    <header className="fixed top-0 left-0 right-0 z-40 bg-white border-b border-slate-100">
      <div className="container flex items-center justify-between h-16 md:h-20">
        <Link
          href="/"
          className="flex items-center space-x-2 rounded-sm u-ring focus:ring-offset-2"
          aria-label="StackScout"
        >
          <Logo className="w-auto h-8 md:h-10" />
        </Link>
        <Nav items={items} />
        <div className="hidden space-x-8 lg:block">
          {ctaItems.map((item, index) => (
            <Link
              key={index}
              className={`px-6 py-3 text-sm font-semibold transition rounded focus:outline-none u-ring ${
                item.targetPage?.url === '/get-started'
                  ? 'text-white bg-primary hover:bg-opacity-90 focus:bg-opacity-90'
                  : 'text-slate-700 hover:bg-slate-100 focus:bg-slate-100'
              }`}
              href={getMenuItemUrl(item)}
            >
              {item.label}
            </Link>
          ))}
        </div>
        <button
          type="button"
          className="relative flex items-center justify-center px-1.5 py-2.5 transition-colors rounded lg:hidden active:bg-slate-100"
          aria-label="Open menu"
          onClick={() => setMobileMenuOpen((open) => !open)}
        >
          <div className="relative w-[26px] h-3">
            <span
              className={`absolute transition-all top-0 left-0 right-0 h-0.5 bg-slate-900 ${
                isMobileMenuOpen && 'transform rotate-45 translate-y-1.5'
              }`}
            />
            <span
              className={`absolute transition-all left-0 right-0 h-0.5 top-1/2 bg-slate-900 ${
                isMobileMenuOpen && 'opacity-0'
              }`}
            />
            <span
              className={`absolute transition-all left-0 right-0 h-0.5 top-full bg-slate-900 ${
                isMobileMenuOpen && 'transform -rotate-45 -translate-y-1.5'
              }`}
            />
          </div>
        </button>
      </div>

      <AnimatePresence>
        {isMobileMenuOpen && <MobileMenu items={items} ctaItems={ctaItems} />}
      </AnimatePresence>
    </header>
  );
};

export default Header;
